import { render, staticRenderFns } from "./GlobalNotice.vue?vue&type=template&id=5bebc519&scoped=true"
import script from "./GlobalNotice.vue?vue&type=script&lang=js"
export * from "./GlobalNotice.vue?vue&type=script&lang=js"
import style0 from "./GlobalNotice.vue?vue&type=style&index=0&id=5bebc519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebc519",
  null
  
)

export default component.exports